var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolyhedral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.401,
    height: 27,
    viewBox: "0 0 29.401 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M160,149.333h12.106v19.125H160Z",
    transform: "translate(-153.082 -141.458)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M330.667,82.458v19.13l8.227-3.211a.57.57,0,0,0,.42-.483V79Z",
    transform: "translate(-309.914 -74.831)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M74.667,98a.493.493,0,0,0,.253.4l4.936,3.211V82.479L74.667,79.1Z",
    transform: "translate(-74.667 -74.933)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M109.957.164A1.14,1.14,0,0,0,109.345,0H95.509a1.217,1.217,0,0,0-.444.08L87,3.229,92.41,6.75h13.232l8.938-3.577Z",
    transform: "translate(-85.997)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolyhedral);
export default __webpack_public_path__ + "static/media/polyhedral.1a204fbe992a458e9a755c2546dcddf5.svg";
export { ForwardRef as ReactComponent };